import CampaignMusic from './CampaignMusic.vue'

export default CampaignMusic
